export default __webpack_public_path__ + "static/media/sibare.91b14a64.png";